import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { GLOBAL } from "./global";

@Injectable({
  providedIn: "root",
})
export class CarriesService {
  public url: string;
  public urlC: string;
  public urlUser: string;
  public token;
  public headers;

  constructor(private _http: HttpClient) {
    this.url = `${GLOBAL.url}/shipment/listcarriers`;
    this.urlC = `${GLOBAL.url}/carrier/`;
    this.token = JSON.parse(localStorage.getItem("token"));
    if (this.token === "undefined") {
      this.token = null;
    }
    this.headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
  }

  showAll(
    type?: any,
    getAll?: any,
    activo?: any,
    page?: any,
    perPage?: any,
    filtros: any[] = [],
    order?: any
  ): Observable<any> {
    const safeInt = (value: any, defaultValue: number): number => {
      const n = parseInt(value);
      return isNaN(n) || n < 1 ? defaultValue : n;
    };

    type = type ?? "ALL";
    getAll = getAll ?? 0;
    page = safeInt(page, 1);
    perPage = safeInt(perPage, 10);
    activo = activo ?? 1;

    let params = `authorization=${this.token}`;
    if (order) {
      params += `&order=${encodeURIComponent(JSON.stringify(order))}`;
    }
    if (activo !== undefined && activo !== 1) {
      params += `&active=${encodeURIComponent(JSON.stringify(activo))}`;
    }

    const buildQueryParams = (): string => {
      let qp = `?page=${page}&perpage=${perPage}&showall=${getAll}`;
      filtros.forEach((filtro) => {
        if (filtro?.value) {
          qp += `&${filtro.key}=${encodeURIComponent(filtro.value)}`;
          if (filtro.key_type) {
            qp += `&${filtro.key_type}=${encodeURIComponent(filtro.type)}`;
          }
        }
      });
      return qp;
    };

    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this._http
      .post<any>(`${this.urlC}list${buildQueryParams()}`, params, { headers })
      .pipe(map((res) => res));
  }

  getAccounts(id = null, filtroCarrier = null): Observable<any> {
    let url = `${this.urlC}listbycompany/${id}?`;
    if(filtroCarrier && filtroCarrier.filter_status && filtroCarrier.filter_status == 1)
      url = url + `filter_status=1`
    return this.petition(url);
  }
  create(json: any): Observable<any> {
    return this.petition(`${this.urlC}new`, json);
  }
  update(id: any, json: any): Observable<any> {
    return this.petition(`${this.urlC}edit/${id}`, json);
  }
  updateSpecific(id: any, json: any): Observable<any> {
    return this.petition(`${this.urlC}specificedit/${id}`, json);
  }
  detail(id: any): Observable<any> {
    return this.petition(`${this.urlC}detail/${id}`);
  }
  enable(id: any, json: any = null, masive?: any): Observable<any> {
    this.token = JSON.parse(localStorage.getItem("token"));

    let params = `authorization=${this.token}`;

    // masive
    if (masive) {
      const masiveEncoded = encodeURIComponent(JSON.stringify(masive));
      params += `&masive=${masiveEncoded}`;
    }

    // normal
    if (json) {
      const jsonEncoded = encodeURIComponent(JSON.stringify(json));
      params += `&json=${jsonEncoded}`;
    }

    const url = `${this.urlC}enable/${id}`;

    return this._http
      .post(url, params, {
        headers: new HttpHeaders({
          "Content-Type": "application/x-www-form-urlencoded",
          "X-Requested-With": "XMLHttpRequest",
        }),
      })
      .pipe(map((res: any) => res));
  }
  delete(id: any): Observable<any> {
    return this.petition(`${this.urlC}remove/${id}`);
  }

  petition(
    url: string,
    json: any = null,
    type: string | null = null
  ): Observable<any> {
    this.token = JSON.parse(localStorage.getItem("token"));

    let paramas;
    paramas = `authorization=${this.token}`;

    if (json != null) {
      json = encodeURIComponent(JSON.stringify(json));
      paramas = `${paramas}&json=${json}`;
    }

    if (type != null) {
      paramas = `${paramas}&type=${type}`;
    }

    return this._http
      .post(url, paramas, { headers: this.headers })
      .pipe(map((res: any) => res)); // sin .json()
  }
}
